import { useState } from 'react';
import { useActivity } from '../hooks/useActivity';
import { formatEntry } from '../lib/activityFormat';

function relativeTime(iso: string): string {
  if (!iso) return '';
  const d = new Date(iso).getTime();
  if (Number.isNaN(d)) return '';
  const diffMs = Date.now() - d;
  const days = Math.floor(diffMs / 86_400_000);
  if (days >= 1) return `${days}d ago`;
  const hours = Math.floor(diffMs / 3_600_000);
  if (hours >= 1) return `${hours}h ago`;
  const mins = Math.floor(diffMs / 60_000);
  if (mins >= 1) return `${mins}m ago`;
  return 'just now';
}

const INITIAL_LIMIT = 30;

export function ActivityTimeline({ itemId, expanded }: { itemId: string; expanded: boolean }) {
  const { data } = useActivity(itemId, { enabled: expanded });
  const [showAll, setShowAll] = useState(false);
  if (!expanded) return null;
  if (!data) return <p className="text-xs italic text-slate-400">Loading activity…</p>;
  if (data.length === 0) return <p className="text-xs italic text-slate-400">No activity yet.</p>;

  const visible = showAll ? data : data.slice(0, INITIAL_LIMIT);
  return (
    <div>
      <ul className="space-y-2">
        {visible.map((e) => {
          const { verb, detail } = formatEntry(e);
          return (
            <li key={e.id} className="text-xs text-slate-700">
              <div className="flex items-baseline gap-2">
                <span className="text-slate-500" title={e.at}>{relativeTime(e.at)}</span>
                <span className="font-medium text-slate-700">{e.actor.displayName}</span>
                <span>{verb}</span>
              </div>
              {detail && <div className="ml-2 mt-0.5 text-slate-500 italic">{detail}</div>}
            </li>
          );
        })}
      </ul>
      {!showAll && data.length > INITIAL_LIMIT && (
        <button type="button" onClick={() => setShowAll(true)} className="mt-2 text-xs text-brand-dark underline">
          Show {data.length - INITIAL_LIMIT} more
        </button>
      )}
    </div>
  );
}
